/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginRespose } from '../../models/login-respose';

export interface AuthValidateAuthAppCodeWithoutLogin$Params {
  authCode?: string | null;
  username?: string | null;
}

export function authValidateAuthAppCodeWithoutLogin(http: HttpClient, rootUrl: string, params?: AuthValidateAuthAppCodeWithoutLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginRespose>> {
  const rb = new RequestBuilder(rootUrl, authValidateAuthAppCodeWithoutLogin.PATH, 'get');
  if (params) {
    rb.query('authCode', params.authCode, {});
    rb.query('username', params.username, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginRespose>;
    })
  );
}

authValidateAuthAppCodeWithoutLogin.PATH = '/api/Auth/ValidateAuthAppCodeWithoutLogin';
